<template>
  <payout-form-group>
    <template v-slot:labelinner>
      <slot name="label-inner" v-if="!$slots['label-inner']">
        <template v-if="warning">
          &nbsp;
        </template>
        <template v-if="!warning">
          <i class="glyphicon glyphicon-question-sign hint-panel-question-icon"></i>
        </template>
      </slot>
    </template>
    <div class="form-control-space">
      <payout-hint-panel :heading="heading" :warning="warning"><slot></slot></payout-hint-panel>
    </div>
  </payout-form-group>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutHintPanel from "@/components/forms/payout/PayoutHintPanel.vue";

@Component({
  name: "PayoutHintPanelFormGroup",
  components: {PayoutHintPanel, PayoutFormGroup}
})
export default class PayoutHintPanelFormGroup extends Vue{
  @Prop({default: null})
  heading: string | null

  @Prop({default: null})
  linkText: string | null

  @Prop({ default: false })
  warning!: boolean

}
</script>

<style scoped>

</style>
